import { databases } from "@/lib/appwrite";
import { Query } from "appwrite";
import { getAllAvatarUrl } from "@/lib/storage/getAvatar";

const databaseId = import.meta.env.VITE_APPWRITE_DATABASE_ID!;
const collectionId = import.meta.env.VITE_WORKER_PROFILE_COLLECTION_ID!;

export type Profile = {
    $id: string;
    userId: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    secondLastName?: string;
    email?: string;
    occupation?: string;
    occupationAbbreviation?: string;
    bloodType?: string;
    birthday?: string;
    colabDniCode?: string;
    phone1?: string;
    phone2?: string;
    emergencyContact?: string;
    address?: string;
    rolCorp?: string;
    colabCorpCode?: string;
    area?: string;
    idSupervisor?: string;
    supervisorName?: string;
    departmentId?: string;
    joinDate?: string;
    isActive?: boolean;
    leaveDate?: string;
    bank?: string;
    bankAccountNumber?: string;
    bankAccountType?: string;
    keyFunctions?: string;
    keyFunction?: string[];
    archievements?: string;
    archievement?: string[];
    salary?: number;
};

export type CombinedUser = {
    id: string;
    name: string;
    email: string;
    joinedAt: string;
    profile: Profile | null;
    avatarUrl: string;
};

export async function getUserWithProfile(userId: string): Promise<CombinedUser | null> {
    const [profileResult, avatarUrl] = await Promise.all([
        databases.listDocuments(databaseId, collectionId, [
            Query.equal('userId', userId),
            Query.limit(1),
        ]),
        getAllAvatarUrl(userId),
    ]);

    const profileDoc = profileResult.documents[0] as unknown as Profile | undefined;
    if (!profileDoc) return null;

    let supervisorName: string | undefined;
    if (profileDoc.idSupervisor) {
        try {
            const supervisorResult = await databases.listDocuments(databaseId, collectionId, [
                Query.equal('userId', profileDoc.idSupervisor),
                Query.limit(1),
            ]);
            const supervisorProfile = supervisorResult.documents[0] as unknown as Profile | undefined;
            if (supervisorProfile) {
                supervisorName = [supervisorProfile.firstName, supervisorProfile.lastName].filter(Boolean).join(' ');
            }
        } catch {}
    }

    const nameParts = [profileDoc.firstName, profileDoc.middleName, profileDoc.lastName, profileDoc.secondLastName].filter(Boolean);

    return {
        id: profileDoc.userId,
        name: nameParts.join(' ') || 'Sin nombre',
        email: profileDoc.email ?? '',
        joinedAt: profileDoc.joinDate ?? '',
        avatarUrl,
        profile: { ...profileDoc, supervisorName },
    };
}
